import { render, staticRenderFns } from "./categoryAddModal.vue?vue&type=template&id=60b3f722&scoped=true&"
import script from "./categoryAddModal.vue?vue&type=script&lang=js&"
export * from "./categoryAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3f722",
  null
  
)

export default component.exports